<script setup lang="ts">
import ImmersveLogo from '@/assets/ImmersveLogo.vue';
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center">
    <ImmersveLogo class="mb-8 size-12" />
    <slot />
  </div>
</template>
